import React from 'react';
import PropTypes from 'prop-types';
import ReactLinkpile from '@homeaway/react-linkpile';
import {pushEdapEvent} from '../../../utils/edap';

export class LinkpileComponent extends React.Component {
    static propTypes = {
        heading: PropTypes.string,
        hideTabs: PropTypes.bool,
        tabs: PropTypes.array // eslint-disable-line react/forbid-prop-types
    };

    handleItemClick = (item) => () => {
        const eventOptions = {
            actionlocation: 'destination-linkpile',
            eventlbsuuid: item.lbsId,
            eventrefinements: item.type
        };
        const edapOptions = {delayProcessing: true};

        pushEdapEvent('destination.link.click', eventOptions, edapOptions);
    };

    render() {
        const {
            heading,
            hideTabs = true,
            tabs
        } = this.props;

        return (
            <div className="container module linkpile-container">
                <div className="row">
                    <div className="col-xs-12">
                        <h2>{heading}</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <ReactLinkpile
                            handleItemClick={this.handleItemClick}
                            hideTabs={hideTabs}
                            tabs={tabs}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default LinkpileComponent;
